import Button from '../../../Molecules/Button'
import { GetUserGuid } from '../../../Utilities/CookieUtilties/UserCookieUtilities'

import React, { useContext, useEffect, useState } from 'react'

import { getSuperMarketAffinity } from 'Utilities/Instrumentation/SegmentUtilities/segmentFunctions'

import { AddToCartExperienceContext } from 'Contexts/AddToCartExperienceContext/AddToCartExperienceContext'
import { useIsSkuBaseInCart } from 'Contexts/UserSpecificProductDataStore/UserSpecificProductDataStore'

export default function AddToCart({ product, onStartAddToCart }) {
  const isSkuBaseInCart = useIsSkuBaseInCart(product.skuBaseNumber)

  const { handleAddToCartPRP, isVariantDetailsDrawerOpen, isKitDetailsDrawerOpen, isAtcDrawerOpen } =
    useContext(AddToCartExperienceContext)

  useEffect(() => {
    if (isVariantDetailsDrawerOpen || isKitDetailsDrawerOpen || isAtcDrawerOpen) setWaiting(false)
  }, [isVariantDetailsDrawerOpen, isKitDetailsDrawerOpen, isAtcDrawerOpen])

  const [waiting, setWaiting] = useState(false)

  return (
    <Button
      data-testid={`addToCart_button_skuBaseNumber_${product?.skuBaseNumber}`}
      intent={'positive'}
      fill
      invert
      isWaiting={waiting}
      icon={isSkuBaseInCart ? 'check' : null}
      text={'Add to Cart'}
      segmentEvent={{
        event: 'Product Add Started',
        properties: {
          cart_id: GetUserGuid(),
          product_id: product.skuBaseNumber,
          sku: product.skuBaseNumber,
          category: product.segmentCategorization,
          made_in_usa: product.isMadeInUsa,
          name: product.displayTitle,
          brand: product.brand,
          //variant: '200 pieces',
          price: product.pricing?.salePrice || product.lowPrice || null,
          quantity: 1,
          //position: 3,
          url: product.productPageUrl,
          image_url: product.thumbnailImageLink,
          availability: product.availability,
          rating: product.reviewCount ? product.rating : 0,
          reviews: product.reviewCount,
          audience_affinity: getSuperMarketAffinity(product),
        },
      }}
      onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()
        setWaiting(true)
        handleAddToCartPRP(product?.productPageId, product.skuBaseNumber, product?.productPageUrl, product?.quantity)

        if (onStartAddToCart) {
          onStartAddToCart()
        }
      }}
      size={'small'}
    />
  )
}
